<template>
  <div class="columns is-variable is-1">
    <ChartSelectorItem
      v-for="usageItem in USAGE_DEFINITION"
      :key="usageItem.name"
      class="column is-one-third"
      :usageItem="usageItem"
      :usageData="usageDataByName(usageItem.name)"
      :isActiveUsage="isActiveUsage(usageItem.name)"
      @changeUsage="setActiveUsage"
      @reload="reload(usageItem.name)"
    />
  </div>
</template>

<script>
import ChartSelectorItem from "./ChartSelectorItem";
import { USAGE_DEFINITION } from "@/misc/desktopCharts";
import { mapMutations, mapActions } from "vuex";

export default {
  components: {
    ChartSelectorItem,
  },
  props: {
    activeUsage: {
      type: String,
      required: true,
    },
    usageData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      USAGE_DEFINITION,
    };
  },
  methods: {
    ...mapMutations("usage", ["setActiveUsage"]),
    ...mapActions("usage", ["fetchUsage"]),
    isActiveUsage(usageName) {
      return usageName === this.activeUsage;
    },
    usageDataByName(usageName) {
      return this.usageData[usageName];
    },
    reload(usageName) {
      this.fetchUsage(usageName);
    },
  },
};
</script>
